'use strict';

export let CarouselComponent = {
    selector: 'carousel',
    template: require('./carousel.html'),
    bindings: {
        slides: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor($interval) {
            this.activeSlide = 0;
            this.isMouseHover = false;

            $interval(()=> {
                if (!this.isMouseHover) {
                    this.nextSlide();
                }
            }, 7000);
        }

        previousSlide() {
            if (this.activeSlide === 0) {
                this.activeSlide = this.slides.length - 1;
            } else {
                this.activeSlide--;
            }
        }

        nextSlide() {
            if (this.slides.length - 1 === this.activeSlide) {
                this.activeSlide = 0;
            } else {
                this.activeSlide++;
            }
        }

        setSlide(index) {
            this.activeSlide = index;
        }

    }
};



// WEBPACK FOOTER //
// ./client/components/carousel/carousel.component.js